import { trans } from "../../functions";
import { collapseFilters } from "./index/helpers";

export default {
    props: [
        "initialQuery",
        "initialSort",
        "initialPerPage",
        "initialPage",
    ],

    data() {
        return {
            fetchingAuctions: false,
            auctions: { data: [] },
            queryParams: {
                query: this.initialQuery,
                sort: this.initialSort,
                perPage: this.initialPerPage,
                page: this.initialPage
            }
        };
    },

    computed: {
        emptyAuctions() {
            return this.auctions.data.length === 0;
        },

        totalPage() {
            return Math.ceil(this.auctions.total / this.queryParams.perPage);
        },

        showingResults() {
            if (this.emptyAuctions) {
                return;
            }

            return trans("storefront::auction.showing_results", {
                from: this.auctions.from,
                to: this.auctions.to,
                total: this.auctions.total
            });
        }
    },

    mounted() {
        if (FleetCart.loggedIn) {
            this.addEventListeners();
            this.fetchAuctions();
        } else {
            return (window.location.href = route("login"));
        }
    },

    methods: {
        addEventListeners() {
            $(this.$refs.sortSelect).on("change", e => {
                this.queryParams.sort = e.currentTarget.value;

                this.fetchAuctions();
            });

            $(this.$refs.perPageSelect).on("change", e => {
                this.queryParams.perPage = e.currentTarget.value;

                this.fetchAuctions();
            });
        },

        changePage(page) {
            this.queryParams.page = page;

            this.fetchAuctions();
        },

        fetchAuctions(options = { updateAttributeFilters: true }) {
            this.fetchingAuctions = true;

            $.ajax({
                url: route("storefront.auctions.index", this.queryParams)
            })
                .then(response => {
                    this.auctions = response;

                    this.$nextTick(() => {
                        collapseFilters();
                    });
                })
                .catch(xhr => {
                    this.$notify(xhr.responseJSON.message);
                })
                .always(() => {
                    this.fetchingAuctions = false;
                });
        }
    }
};
